import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=2e4749a1&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=js&"
export * from "./InfoBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=2e4749a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4749a1",
  null
  
)

export default component.exports